import { useTranslations } from '@vocab/react';
import {
  Box,
  Text,
  TooltipRenderer,
  Stack,
  Inline,
  IconHelp,
  List,
  IconTip,
  Link,
} from 'braid-design-system';

import { COMMUNITY_GUIDLINES } from 'src/core/domain/constants';

import translations from './.vocab';

export default () => {
  const { t } = useTranslations(translations);
  return (
    <Inline space="xxlarge">
      <TooltipRenderer
        id=""
        placement="top"
        tooltip={
          <Stack space="medium">
            <List>
              <Text size="standard" weight="medium">
                {t('tooltipMessageLanguage')}
              </Text>
              <Text size="standard" weight="medium">
                {t('tooltipMessageRIght')}
              </Text>
              <Text size="standard" weight="medium">
                {t('tooltipMessageShort')}
              </Text>
            </List>
          </Stack>
        }
      >
        {({ triggerProps }) => (
          <Inline space="small" align="center">
            <Box aria-label="Help" {...triggerProps}>
              <Inline space="small" alignY="center">
                <IconHelp />
                <Text size="standard" weight="medium">
                  {t('tooltipMessageTips')}
                </Text>
              </Inline>
            </Box>
          </Inline>
        )}
      </TooltipRenderer>
      <Inline space="small" alignY="center">
        <Link
          href={COMMUNITY_GUIDLINES}
          target="_blank"
          style={{ textDecoration: 'none' }}
        >
          <Inline space="small" alignY="center">
            <IconTip />
            <Text size="standard" weight="medium">
              {t('tooltipMessageGuidlines')}
            </Text>
          </Inline>
        </Link>
      </Inline>
    </Inline>
  );
};
